<template>
  <div class="row mx-0 mb-3">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="p-0 m-0 mt-4 main-title">新增完工回報</div>
      <template v-if="step == 1">
        <div style="margin-top: 2rem">
          <commonQueryInput
            :inputItems="multiInputItems"
            v-model:getValue="multiInputVal"
            buttonName="下一步"
          ></commonQueryInput>
        </div>
      </template>
      <template v-else-if="step == 2">
        <template v-if="detailData.sourceData.length != 0">
          <div class="d-flex justify-content-end text-end mb-3">
            <div
              class="py-1 px-2"
              style="background: #c8c9ca; min-width: max-content"
            >
              <span>異動人員：{{ username }}</span>
            </div>
          </div>
          <workorderTable
            :workorderItem="detailData.workorderItem"
            class="mb-3"
          />
          <orderDataTemplate :userSelectCode="buttonSelect" :modStatus="true" />
          <div class="text-end mt-3">
            <button
              type="button"
              class="btn p-0 me-2"
              style="
                color: #fff;
                background-color: #4b8c80;
                width: 6rem;
                height: 2rem;
                font-size: 1.125rem;
              "
              @click="step = 1"
            >
              上一步
            </button>
            <button
              type="button"
              class="btn p-0"
              style="
                color: #fff;
                background-color: #4b8c80;
                width: 6rem;
                height: 2rem;
                font-size: 1.125rem;
              "
              @click="checkAdd"
            >
              確認新增
            </button>
          </div>
        </template>
      </template>
    </div>
    <div class="col-1"></div>
  </div>
  <commonModal :modalShow="modalShow" :size="'xl'">
    <template v-slot:modalheader></template>
    <template v-slot:default>
      <div class="row">
        <div class="col-12 px-5 text-center">
          <div>
            <p>
              {{ modalMsg }}
            </p>
          </div>
          <template v-if="modalConfirm">
            <div>
              <button
                class="btn addOrderRecord-button me-2 mb-1"
                style="margin-right: 40px"
                @click="modalShow = false"
              >
                取消
              </button>
              <button
                class="btn addOrderRecord-button me-2 mb-1"
                @click="
                  (modalShow = false),
                    getWorkorderData(detailData.workCode, detailData.operID)
                "
              >
                確認
              </button>
            </div>
          </template>
          <template v-else>
            <button
              class="btn addOrderRecord-button"
              @click="modalShow = false"
            >
              確認
            </button>
          </template>
        </div>
      </div>
    </template>
  </commonModal>
</template>
  
<script>
import commonQueryInput from "@/components/commonQueryInput.vue";
import commonTable from "@/components/commonTable.vue";
import workorderTable from "@/components/orderManagement/orderDataTemplate/table/workorderTable.vue";
import orderDataTemplate from "@/components/orderManagement/orderDataTemplate.vue";
import commonModal from "@/components/commonModal.vue";
import { computed, inject, provide, ref, watch } from "vue";
import { useStore } from "vuex";
export default {
  components: {
    commonQueryInput,
    commonTable,
    workorderTable,
    orderDataTemplate,
    commonModal,
  },
  setup() {
    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    const oper = computed(() => store.getters["selectOptions/get_orgProcess"]);

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const username = ref(loginData.value.username);

    const path = inject("path");
    const step = ref(1);
    const modalShow = ref(false);
    const modalMsg = ref("");
    const modalConfirm = ref(false);
    const multiInputVal = ref();
    const multiInputItems = ref([
      {
        key: "workCode",
        label: "派工單號",
        type: "text",
        checkEmpty: true,
      },
      {
        key: "oper",
        label: "製程",
        type: "select",
        checkEmpty: true,
        disableText: "-- 選擇製程 --",
        options: oper,
      },
    ]);

    //確認是否能夠新增工單
    const nextStep = (queryOrderValue) => {
      let workID = queryOrderValue["workCode"];
      let processSelected = queryOrderValue["oper"];
      detailData.value = {
        operID: processSelected,
        workCode: workID,
        sourceData: [],
        workorderItem: [],
      };
      var params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = path.value;
      console.log(path.value);
      params["methods"] = "POST";
      params["workID"] = workID;
      params["whichFunction"] = "selectOrderCheck";
      methods.axiosAction(params).then(() => {
        let result = axiosResult.value;
        if (result["Response"] == "ok") {
          let this_status = result.QueryTableData;
          let alertMsg = "";
          modalMsg.value = "";
          modalConfirm.value = false;
          if (processSelected == 5) {
            if (
              this_status == 1 ||
              this_status == 2 ||
              this_status == 3 ||
              this_status == "M" ||
              this_status == "T" ||
              this_status == "N" ||
              this_status == "H"
            ) {
              alertMsg = `${workID}打頭製程已完工，若需調整資料請至修改完工回報`;
            } else if (this_status == "E") {
              modalMsg.value = `${workID}打頭製程已完工，若為製程重工須補資料請按確認`;
              modalConfirm.value = true;
            }
          } else if (processSelected == 6) {
            if (this_status == 2 || this_status == "M" || this_status == "H") {
              alertMsg = `${workID}輾牙製程已完工，若需調整資料請至修改完工回報`;
            } else if (
              this_status == "T" ||
              this_status == 3 ||
              this_status == "N"
            ) {
              modalMsg.value = `${workID}輾牙製程已完工，若為製程重工須補資料請按確認`;
              modalConfirm.value = true;
            } else if (this_status == 0) {
              modalMsg.value = `${workID}打頭製程未完工，請先新增打頭製程完工回報資料`;
            }
          } else if (processSelected == 7) {
            if (this_status == 3 || this_status == "N" || this_status == "H") {
              modalMsg.value = `${workID}熱處理製程已完工，若為製程重工須補資料請按確認`;
              modalConfirm.value = true;
            } else if (
              this_status == 0 ||
              this_status == 1 ||
              this_status == "E" ||
              this_status == "T"
            ) {
              modalMsg.value = `${workID}輾牙製程未完工，請先新增輾牙製程完工回報資料`;
            }
          }
          if (alertMsg != "") {
            methods.setTimeoutAlert(alertMsg);
          } else if (modalMsg.value != "") {
            modalShow.value = true;
          }
          if (alertMsg == "" && modalMsg.value == "") {
            getWorkorderData(workID, processSelected);
          }
        } else {
          if (result["Response"] == "online") {
            let project_name = "-";
            if (result.QueryTableData == "R") {
              project_name = "打頭";
            } else if (result.QueryTableData == "W") {
              project_name = "輾牙";
            } else if (result.QueryTableData == "D") {
              project_name = "熱處理";
            }
            methods.setTimeoutAlert(
              `${workID}正在${project_name}加工中，欲新增資料請待APP結單`
            );
          } else {
            methods.setTimeoutAlert(result.Response);
          }
        }
      });
    };

    //取得工單基本資料
    const getWorkorderData = (workID, processSelected) => {
      methods.triggerLoadingBar();
      var params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = path.value;
      params["methods"] = "POST";
      params["workID"] = workID;
      params["processSelected"] = processSelected;
      params["whichFunction"] = "getWorkorderData";
      methods.axiosAction(params).then(() => {
        methods.triggerLoadingBar();
        let result = axiosResult.value;
        if (result["Response"] == "ok") {
          nextStepGO(result.QueryTableData);
        } else {
          methods.setTimeoutAlert(result.Response);
        }
      });
    };

    //新增工單資料處理
    const nextStepGO = (returnData) => {
      console.log(returnData);
      let workID = returnData.workID;
      let processID = returnData.processSelected;
      let workorderItem = returnData.workorderItem;
      let sourceData = returnData.sourceData;
      detailData.value.workorderItem = workorderItem;
      if (processID == 5) {
        sourceData.forEach((data) => {
          data.wireItem.push({
            index: "",
            in_scroll_no: "",
            scroll_no: "",
            orgScroll_no: "",
            code: "",
            chinese_name: "",
            furnaceCode: "",
            in_consumption: "",
            consumption: "",
            orgConsumption: "",
            org_code: "",
            reason: [],
            del: "",
          });
          data.runcardItem.push({
            index: "",
            in_runcard_code: "",
            runcard_code: "",
            orgRuncard_code: "",
            in_furnace_code: "",
            furnace_code: "",
            orgFurnace_code: "",
            in_screw_weight: "",
            screw_weight: "",
            orgScrew_weight: "",
            in_bucket_weight: "",
            bucket_weight: "",
            orgBucket_weight: "",
            reason: [],
            del: "",
          });
        });
      } else if (processID == 6) {
        sourceData.forEach((data) => {
          data.runcardItem.push({
            index: "",
            in_runcard_code: "",
            runcard_code: "",
            orgRuncard_code: "",
            in_furnace_code: "",
            furnace_code: "",
            orgFurnace_code: "",
            in_screw_weight: "",
            screw_weight: "",
            orgScrew_weight: "",
            in_bucket_weight: "",
            bucket_weight: "",
            orgBucket_weight: "",
            reason: [],
            del: "",
          });
        });
      } else if (processID == 7) {
        sourceData.forEach((data) => {
          data.runcardItem.push({
            index: "",
            in_runcard_code: "",
            runcard_code: "",
            orgRuncard_code: "",
            in_furnace_code: "",
            furnace_code: "",
            orgFurnace_code: "",
            in_screw_weight: "",
            screw_weight: "",
            orgScrew_weight: "",
            in_bucket_weight: "",
            bucket_weight: "",
            orgBucket_weight: "",
            reason: [],
            del: "",
          });
        });
      }
      detailData.value.workCode = workID;
      detailData.value.sourceData = sourceData;
      detailData.value.operID = processID;
      step.value = 2;
    };

    //確認新增檢查資料
    const checkAdd = () => {
      let addData = [];
      let erro = false;
      detailData.value.sourceData.forEach((data) => {
        data.reasonData = "";
        let wireItem = [];
        console.log(data.wireItem);
        if (data.wireItem != undefined) {
          data.wireItem.forEach((wireItemData, index) => {
            if (index == data.wireItem.length - 1) {
              return;
            }
            if (wireItemData.scroll_no == "") {
              erro = true;
              methods.setTimeoutAlert(`線材捲號尚未輸入`);
              return;
            }
            if (wireItemData.consumption == "") {
              erro = true;
              methods.setTimeoutAlert(`耗用量尚未輸入`);
              return;
            }
            wireItem.push({
              scroll_no: wireItemData.scroll_no,
              code: wireItemData.code,
              chinese_name: wireItemData.chinese_name,
              furnaceCode: wireItemData.furnaceCode,
              consumption: wireItemData.consumption,
              org_code: wireItemData.org_code,
            });
          });
          if (erro) {
            return;
          }
        }

        if (data.unit_actual_weight != undefined) {
          if (data.unit_actual_weight == "") {
            erro = true;
            methods.setTimeoutAlert(`單支重尚未輸入`);
            return;
          }
        }

        let runcardItem = [];
        console.log(data.runcardItem);
        if (data.runcardItem != undefined) {
          data.runcardItem.forEach((runcardItemData, index) => {
            if (index == data.runcardItem.length - 1) {
              return;
            }
            if (runcardItemData.runcard_code == "") {
              erro = true;
              methods.setTimeoutAlert(`流程卡號尚未輸入`);
              return;
            }
            if (runcardItemData.furnace_code == "") {
              erro = true;
              methods.setTimeoutAlert(`爐號尚未輸入`);
              return;
            }
            if (runcardItemData.screw_weight == "") {
              erro = true;
              methods.setTimeoutAlert(`重量尚未輸入`);
              return;
            }
            if (runcardItemData.bucket_weight == "") {
              erro = true;
              methods.setTimeoutAlert(`桶重尚未輸入`);
              return;
            }
            runcardItem.push({
              runcard_code: runcardItemData.runcard_code,
              furnace_code: runcardItemData.furnace_code,
              screw_weight: runcardItemData.screw_weight,
              bucket_weight: runcardItemData.bucket_weight,
            });
          });
          if (erro) {
            return;
          }
        }

        let totalProduceTimeItem = [];
        data.totalProduceTimeItem.forEach((totalProduceTimeItemData) => {
          if (totalProduceTimeItemData.device_name == "") {
            erro = true;
            methods.setTimeoutAlert(`機台編號尚未輸入`);
            return;
          }
          totalProduceTimeItem.push({
            code: totalProduceTimeItemData.code,
            device_name: totalProduceTimeItemData.device_name,
            startTime: totalProduceTimeItemData.startTime,
            endTime: totalProduceTimeItemData.endTime,
            totalTime: totalProduceTimeItemData.totalTime,
          });
        });

        if (erro) {
          return;
        }

        addData.push({
          processID: detailData.value.operID,
          workorderBind: data.workorderBind,
          wireItem: wireItem,
          unit_actual_weight: data.unit_actual_weight,
          runcardItem: runcardItem,
          totalProduceTimeItem: totalProduceTimeItem,
          reason: data.reason,
          reasonData: data.reasonData,
        });
      });

      if (erro) {
        return;
      }
      methods.triggerLoadingBar();
      var params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = path.value;
      params["methods"] = "POST";
      params["data"] = addData;
      params["changeUser"] = loginData.value.account;
      params["whichFunction"] = "addCompleteOrder";
      methods.axiosAction(params).then(() => {
        methods.triggerLoadingBar();
        let result = axiosResult.value;
        if (result["Response"] == "ok") {
          methods.setTimeoutAlert(`新增完成`);
        } else {
          methods.setTimeoutAlert(`異常，請再次確認`);
        }
      });
    };

    const buttonSelect = ref(0);

    const detailData = ref({
      operID: "",
      workCode: "",
      sourceData: [],
      workorderItem: [],
    });

    //watch 按查詢鍵回傳所有輸入框的值
    watch(
      multiInputVal,
      (newValue) => {
        nextStep(newValue);
      },
      { deep: true }
    );

    provide("orderManagementDetailData", detailData);
    return {
      username,
      step,
      modalShow,
      modalMsg,
      modalConfirm,
      multiInputVal,
      multiInputItems,
      nextStep,
      buttonSelect,
      getWorkorderData,
      checkAdd,
      detailData,
    };
  },
};
</script>
  
  <style scoped>
.addOrderRecord-button {
  width: 6rem;
  height: 2rem;
  font-size: 1.125rem;
  line-height: 1;
  padding: 0px;
  background-color: var(--main-bg-color);
  color: var(--main-font-color);
}
.modOrderRecord-button {
  width: 53px;
  height: 22px;
  line-height: 22px;
  padding: 0px;
  background-color: var(--main-bg-color);
  color: var(--main-font-color);
  border: 0px;
}
.modOrderRecord-button {
  width: 53px;
  height: 22px;
  line-height: 22px;
  padding: 0px;
  background-color: var(--main-bg-color);
  color: var(--main-font-color);
  border: 0px;
}

.modOrderRecord-button:hover {
  color: var(--main-font-color);
}

.modOrderRecord-order-button {
  height: 2rem;
  padding: 0;
  width: 4.25rem;
  color: var(--main-font-color);
  background-color: var(--main-status-secondary-color);
  border-color: var(--main-status-secondary-color);
}

.modOrderRecord-order-button:hover {
  color: var(--main-font-color);
}

.modOrderRecord-order-button.active {
  background-color: var(--main-bg-color);
  border-color: var(--main-bg-color);
}
</style>